/** URLs y videos oficiales — una sola fuente para toda la web pública */

export const TWITCH_URL = 'https://www.twitch.tv/euge_nial';
export const INSTAGRAM_URL = 'https://www.instagram.com/euge_nial_/';
export const DISCORD_URL = 'https://discord.gg/TEVtZx3pdD';

export const YOUTUBE_CERAMICA_URL = 'https://www.youtube.com/@CeramiCalmaASMR';
export const YOUTUBE_ASMR_URL = 'https://www.youtube.com/@EugenialASMR';

export const YOUTUBE_VIDEO_CERAMICA_ID = '5GErC6YEWM8';
export const YOUTUBE_VIDEO_ASMR_ID = 'e2CXdhIp3eo';

/** Imágenes locales (web/public/images/) */
export const IMAGE_EUGENIA = '/images/euge-nial.png';
export const IMAGE_INSTAGRAM_PREVIEW = '/images/instagram.png';
export const IMAGE_TWITCH_PREVIEW = '/images/twitch-back.png';

export function youtubeEmbed(videoId: string) {
  return `https://www.youtube.com/embed/${videoId}`;
}

export function youtubeThumbnail(videoId: string) {
  return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
}
